import React, { useEffect, useState } from "react";
import style from "./index.module.scss";
import { InputNumber, Input, Button, message } from "antd";
import useModalHandler from "utils/useModalHandler";
import MembersScoreModal from "./Components/MembersScoreModal";
import {
    correctGroupActivityTask,
    ForCheckHomework,
    MemberGradeListItem
} from "service/group";
import { ResultMessage } from "components/ResultMessage";
import { errorMessage } from "service/service";
import { useUpdateStaticsList } from "../../../../store";
import { handleScore } from "utils/common";
import SubmitError from "components/SubmitError";

interface MarkProps {
    homework?: ForCheckHomework; //作答详情
    totalScore?: number; //任务总分
    memberGrade: MemberGradeListItem[]; //学生作答得分
    refreshData: () => void; //刷新
    loading: boolean;
}

export default function Mark({
    homework,
    totalScore,
    memberGrade,
    refreshData,
    loading
}: MarkProps) {
    const { TextArea } = Input;
    const modal = useModalHandler();
    const updateStaticsList = useUpdateStaticsList();
    const [score, setScore] = useState<number | undefined>();
    const [comment, setComment] = useState<string | undefined>("");

    useEffect(() => {
        setScore(homework?.score);
        setComment(homework?.remark);
    }, [homework?.score, homework?.remark]);

    function onChange(value: number | undefined) {
        setScore(value ? value : 0);
    }

    function onChangeComment(e: any) {
        setComment(e.target.value);
    }

    const onOk = () => {
        modal.close();
        refreshData();
    };

    const onSave = async () => {
        if (!homework) return;
        const params = {
            id: homework?.id,
            activityId: homework.activityId,
            taskId: homework.taskId,
            groupId: homework.groupId,
            score: handleScore(totalScore || 0, score || 0),
            remark: comment
        };
        try {
            await correctGroupActivityTask(params);
            await updateStaticsList();
            await refreshData();
            message.success("保存成功");
        } catch (e) {
            ResultMessage.error(
                <SubmitError title="保存失败" content={errorMessage(e)} />,
                { width: 300 }
            );
        }
    };
    return (
        <div className={style.root}>
            <div className={style.label}>评分</div>
            <InputNumber
                min={0}
                max={totalScore}
                step={0.1}
                precision={1}
                value={score}
                onChange={onChange}
                onBlur={onSave}
                placeholder="请输入分值"
            />
            <div className={style.tips}>
                说明：默认小组成员相同得分，如需对小组成员单独打分， 请点击
                <Button type="link" onClick={modal.open}>
                    小组成员评分
                </Button>
            </div>
            <div className={style.label}>评语</div>
            <TextArea
                className={style.text}
                rows={20}
                maxLength={500}
                value={comment}
                placeholder="请输入评语"
                onBlur={onSave}
                onChange={e => onChangeComment(e)}
            />

            {modal.render(
                <MembersScoreModal
                    totalScore={totalScore || 0}
                    visible={modal.visible}
                    onCancel={modal.close}
                    onOk={onOk}
                    list={memberGrade || []}
                    loading={loading}
                />
            )}
        </div>
    );
}
